import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, isRef as _isRef, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f8212e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-5 relative data-table" }
const _hoisted_2 = {
  key: 0,
  class: "w-full flex flex-col justify-center items-center absolute top-36"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["onClick"]

import { ref, onMounted, PropType } from "vue"
import { VDataTableServer } from "vuetify/labs/VDataTable"
import { getAllUsers, getUserById } from "@/repositories/users"
import { updateUsers } from "@/repositories/users"
import { reactive } from "vue"
import { useStore } from "@/store"
import { SAVE_USER } from "@/store/mutationsTypes"
import { Notification } from "@/utils/enum"
import { IResales, IUpdateUser } from "@/utils/interfaces"
import UpdateUserModal from "./UpdateUserModal.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'UserDataTable',
  props: {
	data: { type: Array as PropType<IResales[]>, required: true },
},
  emits: [
	"emitError",
	"updateDataTable",
	"enableLoading",
	"sessionExperid",
],
  setup(__props, { emit }) {

const props = __props;

const store = useStore()

let users = ref<IResales[]>([])
let perPage = ref(10)
let key = ref(-1)
let page = ref(1)
let totalPages = ref(0)
let username = ref("")
let email = ref("")
let validationError = ref(false)
let showUpdateUserModal = ref(false)

let user: IUpdateUser = reactive({
	email: "",
	id: "",
	username: "",
})

let headers = ref([
	{ title: "Ajustar", key: "adjustment", sortable: false },
	{ title: "Nome usuário", key: "username", sortable: false },
	{ title: "Nome revenda", key: "name", sortable: false },
	{ title: "Email", key: "email", sortable: false },
	{ title: "Revenda", key: "resaleCode", sortable: false },
])





const setPerPage = (value: number) => {
	perPage.value = value

	getUsers()
}

const setPage = async (value: number) => {
	page.value = value

	getUsers()
}

const getUsers = async () => {
	emit("enableLoading", true)
	const res = await getAllUsers(page.value, perPage.value)

	if (res.status == 200) {
		parseUserData(res.data.users)

		totalPages.value = res.data.total_pages
	} else if (res.response.status == 401) {
		emit(
			"emitError",
			true,
			Notification.TITLE_SESSION_EXPIRED,
			Notification.SUBTITLE_SESSION_EXPIRED
		)
	} else {
		emit(
			"emitError",
			true,
			Notification.TITLE_ERROR,
			Notification.SUBTITLE_ERROR
		)
	}
	emit("enableLoading", false)
}

const getUserId = async (index: number) => {
	if (key.value != index) {
		key.value = index

		const data = users.value.filter((_, key) => key == index)

		const userInfo = await getUserById(data[0].id)

		user = userInfo.user
		showUpdateUserModal.value = true
	} else {
		key.value = -1
		email.value = ""
		username.value = ""
	}
}

const closeUpdateUserModal = (value: boolean) => {
	showUpdateUserModal.value = value
	key.value = -1
}

const updateUser = async (userData: any) => {
	emit("enableLoading", true)

	const res = await updateUsers(user.id, userData)

	if (res?.status == 204) {
		emit("updateDataTable")
	} else if (res?.status == 400) {
		emit(
			"emitError",
			true,
			Notification.TITLE_UPDATE_ERROR,
			Notification.SUBTITLE_UPDATE_ERROR
		)
	} else if (res?.response.status >= 500) {
		emit(
			"emitError",
			true,
			Notification.TITLE_ERROR,
			Notification.SUBTITLE_ERROR
		)
	}

	key.value = -1
	showUpdateUserModal.value = false
	emit("enableLoading", false)
}

onMounted(async () => {
	if (users.value.length == 0) {
		const td = document.getElementsByTagName("td")
		td[0].style.display = "none"

		const footer = document.getElementsByClassName("v-data-table-footer")
		footer[0].setAttribute("style", "margin: 2rem 0")
	}

	if (props.data.length > 0) {
		users.value = props.data
	} else {
		getUsers()
	}
})

const parseUserData = (data: any[]) => {
	const filter = data.filter((e) => e.deletedAt == null)

	users.value = filter.map((item) => {
		// eslint-disable-next-line
		const index = (item.role as any[]).findIndex((e: any) => {
			// eslint-disable-next-line
			if (e.name == process.env.VUE_APP_ROLE_REVENDA) {
				return true
			} else if (e.name == process.env.VUE_APP_ROLE_REVENDA_ADMIN) {
				return true
			}

			return false
		})

		const resaleCode = item.role[index]?.data.codRev || ""

		return {
			id: item.id,
			name: item.name,
			username: item.username,
			email: item.email,
			resaleCode,
		}
	})

	store.commit(SAVE_USER, users.value)
}

return (_ctx: any,_cache: any) => {
  const _component_H2 = _resolveComponent("H2")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(showUpdateUserModal))
      ? (_openBlock(), _createBlock(UpdateUserModal, {
          key: 0,
          "update-user": updateUser,
          "validation-error": _unref(validationError),
          onCloseModal: closeUpdateUserModal
        }, null, 8, ["validation-error"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_unref(users).length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: require('@/assets/Logo-Prime.png'),
              alt: "Logo Prime",
              class: "ml-3"
            }, null, 8, _hoisted_3),
            _createVNode(_component_H2, { class: "text-v_gray3" }, {
              default: _withCtx(() => [
                _createTextVNode("Pesquise suas comissões")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_unref(VDataTableServer), {
        "items-length": _unref(totalPages) * _unref(perPage),
        page: _unref(page),
        headers: _unref(headers),
        items: _unref(users),
        "page-text": `${_unref(page)}-${_unref(perPage)} de ${_unref(totalPages) * _unref(perPage)}`,
        "items-per-page": _unref(perPage),
        "onUpdate:itemsPerPage": [
          _cache[0] || (_cache[0] = ($event: any) => (_isRef(perPage) ? (perPage).value = $event : perPage = $event)),
          setPerPage
        ],
        "items-per-page-text": "Itens por página",
        "expand-on-click": "",
        "item-value": "data",
        "items-per-page-options": [
				{ title: '10', value: 10 },
				{ title: '25', value: 25 },
				{ title: '50', value: 50 },
				{ title: '75', value: 75 },
				{ title: '100', value: 100 },
			],
        "onUpdate:page": setPage
      }, {
        "item.adjustment": _withCtx(({ index }) => [
          _createElementVNode("button", {
            class: _normalizeClass(
						_unref(key) == index
							? 'text-v_green mt-2 mx-2 active:scale-90'
							: 'bg-transparent mt-2 mx-2 active:scale-90'
					),
            onClick: ($event: any) => (getUserId(index))
          }, [
            _createVNode(_component_v_icon, { icon: "mdi-pencil-box-outline" })
          ], 10, _hoisted_4)
        ]),
        _: 1
      }, 8, ["items-length", "page", "headers", "items", "page-text", "items-per-page"])
    ])
  ], 64))
}
}

})